<template>
  <div class="al-c flex-box">
    <span style="line-height: 28px;">选择时间：</span>
    <el-button :type="btnType == 'yesterday' ? 'success' : ''" size="mini" @click="setDate('yesterday')">昨日</el-button>
    <el-button :type="btnType == 'today' ? 'success' : ''" size="mini" @click="setDate('today')">今日</el-button>
    <el-button :type="btnType == '7day' ? 'success' : ''" size="mini" @click="setDate('7day')">最近7日</el-button>
    <el-button :type="btnType == '30day' ? 'success' : ''" size="mini" @click="setDate('30day')">最近30日</el-button>
    <el-date-picker class="ml10" v-model="startDate" type="date" placeholder="选择开始时间" format="yyyy-MM-dd" :picker-options="pickOptionForStart" @change="changeValue"></el-date-picker>
    <span class="ml10 mr10">至</span>
    <el-date-picker v-model="endDate" type="date" placeholder="选择结束时间" format="yyyy-MM-dd" :picker-options="pickOptionForEnd" @change="changeValue"></el-date-picker>
  </div>
</template>

<script>
export default {
  name: "DateComp",
  components: {},
  props: ["loading"],
  data() {
    return {
      btnType: "30day",
      startDate: new Date(Date.now() - 3600000 * 24 * 30),
      endDate: new Date(),
      minDate: null,
      pickOptionForStart: {
        disabledDate: time => {
          if (this.endDate) {
            return time.getTime() > this.endDate.getTime() ? true : false;
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      pickOptionForEnd: {
        disabledDate: time => {
          if (this.startDate) {
            return time.getTime() < this.startDate.getTime() ? true : false;
          } else {
            return time.getTime() > Date.now();
          }
        }
      }
    };
  },
  created() {},
  computed: {},
  mounted() {},
  methods: {
    setDate(btnType) {
      this.btnType = btnType;
      switch (btnType) {
        case "yesterday":
          this.startDate = new Date(Date.now() - 3600000 * 24);
          this.endDate = new Date(Date.now() - 3600000 * 24);
          break;
        case "today":
          this.startDate = new Date();
          this.endDate = new Date();
          break;
        case "7day":
          this.startDate = new Date(Date.now() - 3600000 * 24 * 7);
          this.endDate = new Date();
          break;
        case "30day":
          this.startDate = new Date(Date.now() - 3600000 * 24 * 30);
          this.endDate = new Date();
          break;
        default:
          break;
      }
      this.$nextTick(() => {
        this.$emit("change", [
          this.$options.filters.filterDate(this.startDate, "yyyy-MM-dd"),
          this.$options.filters.filterDate(this.endDate, "yyyy-MM-dd")
        ]);
      });
    },
    changeValue(value) {
      this.btnType = "other";
      // if (value && value.length) {
      //   this.$emit("change", [
      //     this.$options.filters.filterDate(this.startDate, "yyyy-MM-dd"),
      //     this.$options.filters.filterDate(this.endDate, "yyyy-MM-dd")
      //   ]);
      // }
    },
    getValue() {
      let startDate =
        this.startDate || new Date(Date.now() - 86400000 * 365 * 10);
      let endDate = this.endDate || new Date();
      return [
        this.$options.filters.filterDate(startDate, "yyyy-MM-dd"),
        this.$options.filters.filterDate(endDate, "yyyy-MM-dd")
      ];
    }
  }
};
</script>

<style scoped>
.title::before,
.title::after {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  margin-top: -1px;
  width: 100px;
  height: 1px;
  background: #475eb7;
}

.title::before {
  right: 130%;
}

.title::after {
  left: 130%;
}
</style>
